import React from "react";

const items = [
  "S.J. Quinney College of Law — High Honors",
  "U.S. Attorney's Office — Trial Award",
  "Clerk to Justice Diana Hagen, Utah Court of Appeals",
  "Brigham Young University — Undergraduate",
  "Treasurer, Utah Employment Lawyers Association",
  "Plaintiff-Side Litigation",
  "Of Counsel — Tomchak Skolout",
];

export default function CredentialsStrip() {
  const doubled = [...items, ...items];
  return (
    <section
      data-testid="credentials-strip"
      aria-label="Credentials"
      className="relative border-y border-[#bfa15f]/25 bg-[#f5f2ea]/60 py-7 overflow-hidden"
    >
      <div className="kb-marquee-track whitespace-nowrap">
        {doubled.map((it, i) => (
          <span
            key={i}
            className="inline-flex items-center px-10 text-[0.78rem] uppercase tracking-[0.32em] text-[#0f172a]"
          >
            <span className="text-[#bfa15f] mr-8 font-serif-display italic text-base normal-case tracking-normal">
              &diams;
            </span>
            {it}
          </span>
        ))}
      </div>
    </section>
  );
}
